import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef, useCallback } from 'react';
import classNames from 'classnames/bind';
import { ClickOutside } from "../../../internal/ClickOutside";
import { DropListDesktop } from "../../../internal/DropList/DropListDesktop";
import styles from "./PaginationSelect.css";
var cx = classNames.bind(styles);
export var DropList = /*#__PURE__*/forwardRef(function DropList(_ref, ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      _onSelect = _ref.onSelect,
      items = _ref.items,
      menuPlacement = _ref.menuPlacement,
      ignoreRefs = _ref.ignoreRefs;
  var dropListDesktopProps = {
    onSelect: function onSelect(item) {
      if (_onSelect) {
        _onSelect(item.value);
      }

      setIsOpen(false);
    },
    items: items
  };
  var handleFiltersListClickOutside = useCallback(function (_ref2) {
    var target = _ref2.target;

    if (!(ref !== null && ref !== void 0 && ref.current.contains(target))) {
      setIsOpen(false);
    }
  }, [ref, setIsOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('list', "list--".concat(menuPlacement))
  }, isOpen && /*#__PURE__*/React.createElement(ClickOutside, {
    onClickOutside: handleFiltersListClickOutside,
    ignoreRefs: ignoreRefs
  }, /*#__PURE__*/React.createElement(DropListDesktop, _extends({}, dropListDesktopProps, {
    ref: ref
  }))));
});